// removed by extract-text-webpack-plugin
module.exports = {"container":"BtnConfirmTemplate__container___wehEp","buttonContainer":"BtnConfirmTemplate__buttonContainer___2r-KT"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/BtnConfirmTemplate.less
 ** module id = 754
 ** module chunks = 0
 **/